import React, { useState } from "react";
import { ExternalLinkIcon } from "@heroicons/react/outline";
import PrimaryButton from "components/Buttons/PrimaryButton";
import CheckBox from "components/FormElements/CheckBox";
import { Form, Formik } from "formik";
import { getLocalStorageItem, setLocalStorageItem } from "helpers/LocalStorage";
import { isTrueOrUndefined } from "Utils";
import { toast } from "react-hot-toast";

export default function AccountPanel(props) {
    const [formValues, setFormValues] = useState({
        hotTips: isTrueOrUndefined(getLocalStorageItem("local_hotTips")),
        autoPublishUploads: isTrueOrUndefined(
            getLocalStorageItem("local_autoPublishUploads")
        ),
    });

    const updateLocalSettings = (values) => {
        setLocalStorageItem("local_hotTips", values.hotTips);
        setLocalStorageItem(
            "local_autoPublishUploads",
            values.autoPublishUploads
        );
        setFormValues(values);
        toast.success("Settings updated");
    };

    return (
        <Formik
            initialValues={formValues}
            enableReinitialize={true}
            onSubmit={updateLocalSettings}
        >
            <Form className="flex h-full w-full flex-col">
                <div className="flex-grow overflow-auto p-4">
                    <div className="flex-grow overflow-auto p-4">
                        <div className="w-full space-y-8">
                            <div>
                                <dt className="text-base font-medium text-gray-900">
                                    Local settings
                                </dt>
                                <dd className="mt-3 space-y-4 text-sm text-gray-500">
                                    <CheckBox
                                        label="Enable Tips"
                                        name="hotTips"
                                        helpertext="Show helpful tips throughout CEO."
                                    />
                                    <CheckBox
                                        label="Publish Uploads Automatically"
                                        name="autoPublishUploads"
                                        helpertext="Default to publishing uploads automatically."
                                    />
                                </dd>
                            </div>
                            <div>
                                <dt className="text-base font-medium text-gray-900">
                                    Email and password settings
                                </dt>
                                <dd className="mt-3 space-y-4 text-sm text-gray-500">
                                    <p>
                                        All of your email and password settings
                                        are handled in SNworks Accounts.
                                    </p>
                                    <PrimaryButton>
                                        <a
                                            href={
                                                process.env
                                                    .REACT_APP_ACCOUNTS_DOMAIN
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex items-center"
                                        >
                                            <ExternalLinkIcon className="mr-2 h-4 w-4" />
                                            Go to SNworks Account Settings
                                        </a>
                                    </PrimaryButton>
                                </dd>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full bg-gray-50 p-2 text-right">
                    <PrimaryButton label="Save Changes" type="submit" />
                </div>
            </Form>
        </Formik>
    );
}
